import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/homeLogo.png";
import Tilt from "react-parallax-tilt";


function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              Martian's <span className="purple"> Purpose </span> 
            </h1>
            <p>
            Martian's purpose is the development of artificial intelligence technologies for Space.
            </p>

          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img src={myImg} className="img-fluid" alt="avatar" />
            </Tilt>
          </Col>

        </Row>
        
      </Container>
    </Container>
  );
}
export default Home2;
